import getLogo from '@/services/general/getLogo';
import {
  TYPOLOGIE_POINT_DE_VENTE,
} from '@/configuration/tiers/tiersConf';

export default async function getLogoClient(client) {
  let logo = await getLogo(client.id);
  if (!logo && client.tiersParentId) {
    logo = await getLogo(client.tiersParentId);
  }
  if (!logo && client.typologie === TYPOLOGIE_POINT_DE_VENTE
      && client.tiersParent && client.tiersParent.tiersParentId) {
    logo = await getLogo(client.tiersParent.tiersParentId);
  }
  return logo;
}
